var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1402 15.4995C10.3911 17.6712 8.38086 20.64 7.3877 23.9999H21.4284C22.848 23.9989 23.9987 22.8482 23.9998 21.4286V11.9722C20.0828 11.8694 16.2491 13.1143 13.1399 15.4992L13.1402 15.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66929 23.7685C6.45463 21.0064 7.85497 18.4587 9.76731 16.3179C9.20482 15.5518 8.54377 14.864 7.79913 14.2737C5.56311 12.5873 2.79461 11.7601 0.000244141 11.9455V21.4285C0.00131548 22.8481 1.152 23.9988 2.57162 23.9998H5.65289C5.64753 23.9227 5.65289 23.8445 5.66896 23.7684L5.66929 23.7685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4289 0.000488281H2.57211C1.15249 0.00155962 0.00180211 1.15225 0.000732422 2.57187V10.2303C3.18074 10.046 6.32207 11.0028 8.86026 12.9281C9.6563 13.556 10.372 14.2802 10.9913 15.0827C11.3373 14.7656 11.6963 14.4517 12.0852 14.1485H12.0841C15.4956 11.5289 19.7009 10.1552 24.0002 10.2581V2.57192C23.9992 1.1523 22.8485 0.00155797 21.4289 0.000488281ZM11.5718 8.57175C10.705 8.57175 9.92397 8.04998 9.59182 7.24856C9.26076 6.44821 9.44397 5.52682 10.0568 4.91397C10.6697 4.30112 11.5911 4.11793 12.3914 4.44898C13.1928 4.78111 13.7146 5.56218 13.7146 6.42896C13.7146 6.9968 13.4885 7.54215 13.0867 7.94392C12.685 8.34568 12.1396 8.57175 11.5718 8.57175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.14fd3f9704d9f8c34cd1c6c21c3a58ff.svg";
export { ForwardRef as ReactComponent };